import { RegularContentLoader } from "components/loader";
import { usePoliciesList, useUser } from "data/ss-data-hooks";
import SettingsPanelLayout from "pages/settings/common/settings-panel-layout";

import { ContactItem } from "./contact-item";

const Contact = () => {
  const user = useUser();
  const { data: policiesList, isLoading } = usePoliciesList();

  if (isLoading || !user) return <RegularContentLoader />;

  const policyItems = policiesList?.map((policy) => (
    <ContactItem
      key={policy.keystonePolicyId}
      policyDetails={{
        policyId: policy.platformPolicyId,
        propertyAddress: policy.propertyAddress ?? {},
        isCommercial: !!policy.isCommercial,
      }}
      userEmail={user.email ?? ""}
    />
  ));

  return <SettingsPanelLayout title="Contact" policyItems={policyItems} />;
};

export default Contact;
